export default "__VITE_ASSET__af69754d__"